import React from "react";
import { Link } from 'react-router-dom'
function  Contact() {
        return(
         <div>
            <br/><br/><br/><br/><br/>
            <div class="section contact" id="contact">
        <div id="map" class="map"></div>
         <div className="container">
            <div className="row">
                <div className="col-lg-8">
                    <div className="contact-form-card">
                      <Link to="/">  <h4 className="contact-title">Send a message</h4> </Link>
                        <form action="">
                            <div className="form-group">
                                <input  className="form-control" type="text" placeholder="Name *" required/>
                            </div>
                            <div className="form-group">
                                <input className="form-control" type="email" placeholder="Email *" required/>
                            </div>
                            <div className="form-group">

                            </div>
                            <div className="form-group ">
                            <Link to="https://chat.whatsapp.com/Bb243XpPFxy3K9YYgR1uEA"> <button type="submit" className="form-control btn btn-primary" >Send Message</button></Link>
                            </div>
                        </form>
                    </div>
                </div>
                <div className="col-lg-4">
                    <div className="contact-info-card">
                        <h4 className="contact-title">Get in touch</h4>
                        <div className="row mb-2">
                            <div className="col-1 pt-1 mr-1">
                                <i className="ti-mobile icon-md"></i>
                            </div>
                            <div className="col-10 ">
                                <h6 className="d-inline">Phone : <br/> <span className="text-muted">+ 8770417166</span></h6>
                            </div>
                        </div>
                        <div className="row mb-2">
                            <div className="col-1 pt-1 mr-1">
                                <i className="ti-map-alt icon-md"></i>
                            </div>
                            <div className="col-10">
                                <h6 className="d-inline">Address :<br/> <span className="text-muted">32,VILLAGE MALENDI KODERIYA MHOW INDORE (MP)</span></h6>
                            </div>
                        </div>
                        <div className="row mb-2">
                            <div className="col-1 pt-1 mr-1">
                                <i className="ti-envelope icon-md"></i>
                            </div>
                            <div className="col-10">
                                <h6 className="d-inline">Email :<br/> <span className="text-muted">chetankumayu2003@gmail.com</span></h6>
                            </div>
                        </div>
                        <ul className="social-icons pt-4">
                        <li className="social-item"><Link className="social-link text-light" to="https://www.facebook.com/profile.php?id=100089544867955"><i className="ti-facebook" aria-hidden="true"></i></Link></li>
                <li className="social-item"><Link className="social-link text-light" to="https://twitter.com/chetan_kumayu?t=37XDQMfRsc-AQ0Eh0Gx7YA&s=09"><i className="ti-twitter" aria-hidden="true"></i></Link></li>
                <li className="social-item"><Link className="social-link text-light" to="#"><i className="ti-google" aria-hidden="true"></i></Link></li>
                <li className="social-item"><Link className="social-link text-light" to="https://instagram.com/24_chetan_kumayu?igshid=YmMyMTA2M2Y="><i className="ti-instagram" aria-hidden="true"></i></Link></li>
                <li className="social-item"><Link className="social-link text-light" to="#"><i className="ti-github" aria-hidden="true"></i></Link></li>
                        </ul> 
                    </div>
                </div>
            </div>

        </div>
        </div>
        </div>)
    }

export default Contact